import { Style } from 'api';

export const EPDM_FOLDER_ID = '23';

const SKILLION_1_ROOF = 2;
const SKILLION_2_ROOF = 3;

// The 3D model ignores the chosen roofing on skillion roofs and draws them all
// as EPDM, a Grasshopper defect reported to ShapeDiver. The price still follows
// the choice, so the customer is told that only the preview is wrong.
const ROOF_TYPES_DRAWN_AS_EPDM = [SKILLION_1_ROOF, SKILLION_2_ROOF];

export const drawsEveryRoofingAsEpdm = (style?: Style): boolean => {
  const { renderParameters = {} } = JSON.parse(
    style?.defaultConfiguration?.style?.ghModelJson || '{}'
  );
  return ROOF_TYPES_DRAWN_AS_EPDM.includes(renderParameters.style_roof_type);
};
